/** Download optional analytics only after consent; never hold up the app. */
export function createDeferredAnalytics<T>(load: () => Promise<T>, onError: (error: unknown) => void) {
  let enabled = false;
  let generation = 0;
  let client: T | null = null;
  let loading: Promise<T> | null = null;

  return {
    enable() { enabled = true; },
    disable() { enabled = false; generation += 1; },
    peek() { return client; },
    async run(operation: (value: T) => void): Promise<boolean> {
      if (!enabled) return false;
      const requestedGeneration = generation;
      try {
        if (!loading) {
          loading = load().then((value) => { client = value; return value; }).catch((error) => {
            loading = null;
            throw error;
          });
        }
        const value = await loading;
        if (enabled && generation === requestedGeneration) {
          operation(value);
          return true;
        }
        return false;
      } catch (error) {
        onError(error);
        return false;
      }
    },
  };
}
